<template>
  <AuthLayout
    eyebrow="Registrierung"
    title="E-Mail bestätigen"
    intro="Schließen Sie Ihre Registrierung ab, indem Sie Ihre E-Mail-Adresse bestätigen."
    card-title="Konto bestätigen"
    card-intro="Ihr Bestätigungslink wird geprüft. Danach können Sie sich im Kundenbereich anmelden."
    :aside-list="[
      'Registrierung abschließen',
      'Zugang zum Kundenbereich freischalten',
      'Danach direkt anmelden'
    ]"
  >
    <div v-if="status === 'loading'" class="auth-confirm-panel" role="status">
      <div class="auth-confirm-panel__eyebrow">Bitte warten</div>
      <h3 class="auth-confirm-panel__title">Bestätigung wird geprüft</h3>
      <p class="auth-confirm-panel__text">
        Ihr Bestätigungslink wird verarbeitet.
      </p>
    </div>

    <div v-else-if="status === 'success'" class="auth-confirm-panel auth-confirm-panel--success" role="status">
      <div class="auth-confirm-panel__eyebrow">Erfolgreich bestätigt</div>
      <h3 class="auth-confirm-panel__title">E-Mail bestätigt</h3>
      <p class="auth-confirm-panel__text">
        Ihr Konto wurde bestätigt. Sie werden zum Login weitergeleitet.
      </p>
    </div>

    <div v-else class="auth-confirm-panel auth-confirm-panel--error" role="alert">
      <div class="auth-confirm-panel__eyebrow">Bestätigung fehlgeschlagen</div>
      <h3 class="auth-confirm-panel__title">Link ungültig oder abgelaufen</h3>
      <p class="auth-confirm-panel__text">
        {{ errorMessage }}
      </p>
      <router-link :to="{ name: 'login' }" class="btn btn-primary mt-3">
        Zum Login
      </router-link>
    </div>
  </AuthLayout>
</template>

<script>
import AuthLayout from '@/components/layout/AuthLayout.vue'
import {useUserStore} from '@/stores/user'

export default {
  name: 'AccountConfirm',
  components: {
    AuthLayout,
  },
  setup() {
    return {
      userStore: useUserStore(),
    }
  },
  data() {
    return {
      status: 'loading',
      errorMessage: 'Der Bestätigungslink konnte nicht verarbeitet werden. Bitte fordern Sie bei Bedarf eine neue Bestätigungs-E-Mail an.',
    }
  },
  created() {
    const token = this.$route.params.token
    if (!token) {
      this.status = 'error'
      this.errorMessage = 'Es wurde kein Bestätigungscode übermittelt.'
      return
    }

    this.userStore.apiAuthAccountConfirmation(token)
        .then(({data}) => {
          if (data?.error) {
            this.status = 'error'
            this.errorMessage = data.message || this.errorMessage
            return
          }

          this.status = 'success'
          window.setTimeout(() => {
            this.$router.push({name: 'login'})
          }, 2000)
        })
        .catch((error) => {
          this.status = 'error'
          this.errorMessage = error?.response?.data?.message || this.errorMessage
        })
  },
}
</script>

<style scoped lang="scss">
.auth-confirm-panel {
  padding: 1.25rem;
  border: 1px solid rgba(12, 58, 83, 0.12);
  background: rgba(13, 79, 113, 0.04);

  &--success {
    border-color: rgba(25, 135, 84, 0.2);
    background: rgba(25, 135, 84, 0.06);
  }

  &--error {
    border-color: rgba(201, 95, 95, 0.2);
    background: rgba(201, 95, 95, 0.06);
  }
}

.auth-confirm-panel__eyebrow {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #6f8799;
}

.auth-confirm-panel__title {
  margin: 0.45rem 0 0.6rem;
  font-size: clamp(1.75rem, 3vw, 2.2rem);
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: #123754;
}

.auth-confirm-panel__text {
  margin: 0;
  color: #5f7283;
}
</style>
